export default __webpack_public_path__ + "media/images/drawlogo_en-b2485ab20eb24f204dccaad5c689ceba.png";